(() => {
  const root = document.querySelector("[data-zc-test-menu]");
  if (!root) return;

  const deptButtons = [...root.querySelectorAll("[data-zc-tm-dept]")];
  const panels = [...root.querySelectorAll("[data-zc-tm-panel]")];

  const openDepartment = (key) => {
    deptButtons.forEach((button) => {
      const on = button.dataset.zcTmDept === key;
      button.classList.toggle("is-open", on);
      button.setAttribute("aria-expanded", on ? "true" : "false");
    });
    panels.forEach((panel) => {
      const on = panel.dataset.zcTmPanel === key;
      panel.classList.toggle("is-open", on);
      panel.hidden = !on;
    });
  };

  const flyouts = [...root.querySelectorAll(".zc-tm-flyout")];

  const closeFlyouts = (except) => {
    flyouts.forEach((flyout) => {
      if (flyout === except) return;
      const button = flyout.querySelector("[data-zc-tm-fly]");
      const list = flyout.querySelector(".zc-tm-flyout__list");
      flyout.classList.remove("is-open");
      if (button) button.setAttribute("aria-expanded", "false");
      if (list) list.hidden = true;
    });
  };

  const toggleFlyout = (flyout) => {
    const button = flyout.querySelector("[data-zc-tm-fly]");
    const list = flyout.querySelector(".zc-tm-flyout__list");
    if (!button || !list) return;
    const open = button.getAttribute("aria-expanded") === "true";
    closeFlyouts(open ? null : flyout);
    flyout.classList.toggle("is-open", !open);
    button.setAttribute("aria-expanded", open ? "false" : "true");
    list.hidden = open;
  };

  flyouts.forEach((flyout) => {
    const button = flyout.querySelector("[data-zc-tm-fly]");
    if (!button) return;
    button.addEventListener("click", (event) => {
      event.stopPropagation();
      toggleFlyout(flyout);
    });
  });

  document.addEventListener("click", (event) => {
    if (event.target.closest(".zc-tm-flyout")) return;
    closeFlyouts();
  });

  deptButtons.forEach((button) => {
    button.addEventListener("click", () => {
      closeFlyouts();
      openDepartment(button.dataset.zcTmDept);
    });
  });

  const activateTab = (layout, key) => {
    layout.querySelectorAll("[data-zc-tm-tab]").forEach((tab) => {
      const on = tab.dataset.zcTmTab === key;
      tab.classList.toggle("is-active", on);
      tab.setAttribute("aria-selected", on ? "true" : "false");
    });
    layout.querySelectorAll("[data-zc-tm-pane]").forEach((pane) => {
      const on = pane.dataset.zcTmPane === key;
      pane.classList.toggle("is-active", on);
      pane.hidden = !on;
    });
  };

  root.querySelectorAll(".zc-tm-rail-layout").forEach((layout) => {
    const tabs = [...layout.querySelectorAll("[data-zc-tm-tab]")];
    if (!tabs.length) return;

    const current = tabs.find((tab) => tab.classList.contains("is-active")) || tabs[0];
    activateTab(layout, current.dataset.zcTmTab);

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => activateTab(layout, tab.dataset.zcTmTab));
      tab.addEventListener("keydown", (event) => {
        const index = tabs.indexOf(tab);
        if (event.key === "ArrowDown" || event.key === "ArrowRight") {
          event.preventDefault();
          const next = tabs[(index + 1) % tabs.length];
          next.focus();
          activateTab(layout, next.dataset.zcTmTab);
        }
        if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
          event.preventDefault();
          const prev = tabs[(index - 1 + tabs.length) % tabs.length];
          prev.focus();
          activateTab(layout, prev.dataset.zcTmTab);
        }
      });
    });
  });

  root.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const openFly = flyouts.find((flyout) => flyout.classList.contains("is-open"));
    if (openFly) {
      closeFlyouts();
      const button = openFly.querySelector("[data-zc-tm-fly]");
      if (button) button.focus();
      return;
    }
    const open = deptButtons.find((button) => button.getAttribute("aria-expanded") === "true");
    if (open) open.focus();
  });
})();
